var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.55 2.55L8.1 6L11.55 9.45C12.15 10.05 12.15 10.95 11.55 11.55C11.25 11.85 10.95 12 10.5 12C10.05 12 9.75 11.85 9.45 11.55L6 8.1L2.55 11.55C2.25 11.85 1.95 12 1.5 12C1.05 12 0.75 11.85 0.45 11.55C-0.15 10.95 -0.15 10.05 0.45 9.45L3.9 6L0.45 2.55C-0.15 1.95 -0.15 1.05 0.45 0.45C1.05 -0.15 1.95 -0.15 2.55 0.45L6 3.9L9.45 0.45C10.05 -0.15 10.95 -0.15 11.55 0.45C12.15 1.05 12.15 1.95 11.55 2.55Z",
    fill: "#003333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.d55ba6866beaa352c5093beff668ef5a.svg";
export { ForwardRef as ReactComponent };